window.parseCurrency = function (amount) {
    if(amount) {
        var parsed = parseFloat(amount.replace(/[^0-9.]/g, ""));
        if (isNaN(parsed)) {
          return '';
        }
        return parsed;
    }
    else {
        return '';
    }
};
